import { ulid } from "ulidx";

type ReminderSource = {
	id?: string;
	pdf?: { quotationCode?: string };
};

export const fallbackReminder = (id?: string): string =>
	Date.now().toString(36) +
	(id?.slice(-4) ?? '') +
	Math.random().toString(36).substring(2);

export const resolveReminderNumber = (
	data: ReminderSource | null | undefined
): string => data?.pdf?.quotationCode || fallbackReminder(data?.id);

export const makeConfigurationCode = (): string => ulid();
